import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import store from "../../../app/store";

const _authToken = () => {
  const state = store.getState();
  return `${state?.authReducer?.userData?.tokenType?.toLowerCase()} ${
    state?.authReducer?.userData?.token
  }`;
};
const _orgClientId = () => {
  const state = store.getState();
  return state?.orgReducer?.selectedFI?.orgClientId
    ? state?.orgReducer?.selectedFI?.orgClientId
    : state?.authReducer?.userData?.client_Id;
};
const _idrssd = () => {
  const state = store.getState();
  return state?.orgReducer?.selectedFI?.idrssd;
};

// ---------------------------------------------------------
// RTK Query API
// ---------------------------------------------------------
export const downloadFHSReportRTK = createApi({
  reducerPath: "downloadFHSReportRTK",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  tagTypes: ["downloadFHSReportRTK"],
  endpoints: (builder) => ({
    // ----------------------------------------
    // GET QUARTER LIST
    // ----------------------------------------
    getDownloadReportQuarterList: builder.query({
      query: () => ({
        url: `/bank/${_idrssd()}/fhs/quarter`,
        method: "GET",
        headers: {
          Authorization: _authToken(),
          "Content-Type": "application/json",
        },
      }),
      transformResponse: (response) => response.data,
      providesTags: ["downloadFHSReportRTK"],
    }),

    // ----------------------------------------
    // GET FHS DATA BASED ON QUARTER
    // ----------------------------------------
    getFHSDataBasedOnQuarter: builder.query({
      query: ({ selectedQuarterParams }) => ({
        url: `bank/${_orgClientId()}/fhs/${_idrssd()}?quarter=${selectedQuarterParams}`,
        method: "GET",
        headers: {
          Authorization: _authToken(),
          "Content-Type": "application/json",
        },
      }),
      providesTags: ["downloadFHSReportRTK"],
    }),

    // ----------------------------------------
    // GET EWI DATA BASED ON QUARTER
    // ----------------------------------------
    getEWIDataBasedOnQuarter: builder.query({
      query: ({ selectedQuarterParams }) => ({
        url: `bank/${_orgClientId()}/ewi/${_idrssd()}?quarter=${selectedQuarterParams}`,
        method: "GET",
        headers: {
          Authorization: _authToken(),
          "Content-Type": "application/json",
        },
      }),
      providesTags: ["downloadFHSReportRTK"],
    }),
  }),
});

export const {
  useGetDownloadReportQuarterListQuery,
  useLazyGetFHSDataBasedOnQuarterQuery,
  useLazyGetEWIDataBasedOnQuarterQuery,
} = downloadFHSReportRTK;
